<template>
  <div class="col-12">
    <b-card>
      <div slot="header">
        <b-row>
          <b-col v-text="$lang.request_detail"></b-col>
          <b-col
            class="text-right"
            v-text="`${$lang.request_number}: ${item.id || ''}`"
          ></b-col>
        </b-row>
      </div>
      <div class="text-center" v-if="loadingItem">
        <b-spinner variant="primary" label="Text Centered"></b-spinner>
      </div>
      <div v-if="!loadingItem && item">
        <b-row>
          <b-col class="mb-4" cols="12">
            <b-card>
              <span class="headerContact" v-text="$lang.requester_info" />
              <b-row>
                <b-col cols="12" md="4" class="py-1">
                  <b v-text="`${$lang.searchContactUs.requester}: `" />
                  <span class="text-muted" v-text="item.requester" />
                </b-col>
                <b-col cols="12" md="4" class="py-1">
                  <b v-text="`${$lang.searchContactUs.mobile}: `" />
                  <span class="text-muted" v-text="item.mobile" />
                </b-col>
                <b-col cols="12" md="4" class="py-1">
                  <b v-text="`${$lang.created_at}: `" />
                  <span
                    class="text-muted"
                    v-text="item.created_at && item.created_at.jalali"
                  />
                </b-col>
                <b-col v-if="item.national_code" cols="12" md="4" class="py-1">
                  <b v-text="`${$lang.national_code}: `" />
                  <span class="text-muted" v-text="item.national_code" />
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col
            cols="12"
            class="mb-4"
            v-if="item.acting_description || item.acting_at"
          >
            <b-card>
              <span class="headerContact" v-text="$lang.acting_info" />
              <b-row>
                <b-col cols="12" md="4" class="py-1">
                  <b v-text="`${$lang.searchContactUs.acting_full_name}: `" />
                  <span class="text-muted" v-text="item.acting_full_name" />
                </b-col>

                <b-col cols="12" md="4" class="py-1">
                  <b v-text="`${$lang.acting_at_jalali}: `" />
                  <span
                    class="text-muted"
                    v-text="item.acting_at && item.acting_at.jalali"
                  />
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col cols="12" class="mb-4">
            <b-card>
              <b-row v-if="item">
                <span class="headerContact" v-text="$lang.request_info" />
                <b-col cols="12" class="py-1">
                  <b v-text="`${$lang.tracking_code}: `" />
                  <span class="text-muted" v-text="item.tracking_code" />
                </b-col>
                <b-col cols="12" class="py-1">
                  <b v-text="`${$lang.description}: `" />
                  <span class="text-muted" v-text="item.description" />
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col cols="12" class="mb-4">
            <UploadFile
              v-if="id"
              keyServies="contact_us"
              :keyValue="id"
              :showAdd="true"
              :file_types="file_types"
              :parentPermissions="parentPermissions"
              :crop="false"
              :outButton="fileButtons"
            />
          </b-col>
          <b-col cols="12" class="mb-4">
            <b-card>
              <span class="headerContact" v-text="$lang.actions" />
              <b-row>
                <b-col>
                  <b-form-group
                    :label="$lang.acting_description"
                    :label-cols="12"
                  >
                    <b-form-textarea
                      id="acting_description"
                      v-model="$v.acting_description.$model"
                      type="text"
                      :autocomplete="$lang.acting_description"
                      :rows="4"
                      :state="
                        $v.acting_description.$dirty
                          ? !$v.acting_description.$error
                          : null
                      "
                    >
                    </b-form-textarea>
                    <b-form-invalid-feedback id="acting_description-feedback">
                      {{
                        $lang.error_required | replace($lang.acting_description)
                      }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="12">
                  <b-form-group
                    :label="$lang.acting_status"
                    label-for="acting_status"
                    :label-cols="$config.form.labelCol"
                  >
                    <requiredComponent
                      slot="label"
                      :label="$lang.acting_status"
                      :rules="$v.acting_status_selected.$params"
                    />
                    <selectFind
                      :options="acting_status_options"
                      v-model="$v.acting_status_selected.$model"
                      label="text"
                      id="value"
                      :isValid="
                        $v.acting_status_selected.$dirty
                          ? !$v.acting_status_selected.$error
                          : null
                      "
                      :loading="acting_status_Loading"
                    />
                    <b-form-invalid-feedback
                      :style="{
                        display: $v.acting_status_selected.$error
                          ? 'block'
                          : 'none',
                      }"
                      id="acting_status_selected_feedback"
                    >
                      {{
                        $lang.error_required
                          | replace($lang.acting_status_selected)
                      }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="12" class="float-right">
                  <div slot="footer" class="form-group form-btn">
                    <b-overlay
                      :show="loading"
                      spinner-small
                      rounded
                      class="d-inline-block"
                    >
                      <b-button
                        @click="postContactUs"
                        v-if="permistions.includes(`admin`)"
                        type="submit"
                        size="md"
                        variant="success"
                      >
                        <i class="fa fa-check"></i>
                        {{ $lang.submitButton }}
                      </b-button>
                    </b-overlay>
                    <b-button
                      type="reset"
                      class="ml-2"
                      size="md"
                      variant="danger"
                      @click="handleBack"
                    >
                      <i class="fa fa-ban"></i>
                      {{ $lang.close }}
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col class="mb-3" cols="12">
            <b-card>
              <span class="headerContact" v-text="$lang.send_sms" />
              <b-row v-if="item">
                <b-col cols="12">
                  <div
                    class="alert alert-warning alert-dismissible fade show"
                    role="alert"
                  >
                    <p class="m-0">
                      {{
                        $lang.send_sms_confim
                          .replace("{0}", item.requester)
                          .replace("{1}", item.mobile)
                      }}
                    </p>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </b-col>
                <b-col cols="12">
                  <b-form-group :label="$lang.message_sms" :label-cols="12">
                    <b-form-textarea
                      id="message_sms"
                      v-model="$v.message_sms.$model"
                      type="text"
                      :autocomplete="$lang.message_sms"
                      :rows="4"
                      :state="
                        $v.message_sms.$dirty ? !$v.message_sms.$error : null
                      "
                    >
                    </b-form-textarea>
                    <b-form-invalid-feedback id="message_sms-feedback">
                      {{ $lang.error_required | replace($lang.message_sms) }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-button
                    @click="postSms"
                    v-if="permistions.includes(`admin`)"
                    class="float-right"
                    variant="primary"
                    :disabled="disableSendSms"
                  >
                    <div v-if="!loading">
                      {{ $lang.send_sms }}
                      <span key="fa-check"><i class="fa fa-check"></i></span>
                    </div>
                    <div v-if="loading">
                      <b-spinner small></b-spinner>
                      <span> {{ $lang.search.loading_send }}</span>
                    </div>
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import { renderEumOptions } from "@/shared/utils";
import { pathOr } from "ramda";
import { required } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import UploadFile from "@/components/base/uploadFile";

export default {
  validations: {
    acting_description: {
      required,
    },
    acting_status_selected: {
      required,
    },
    message_sms: {},
  },
  components: {
    UploadFile,
  },
  inject: ["contactUsRepository"],
  data() {
    return {
      id: this.$route.params.id,
      item: {},
      loadingItem: false,
      acting_description: null,
      acting_status_selected: {},
      acting_status_Loading: false,
      message_sms: null,
      disableSendSms: false,
      loading: false,
      parentPermissions: ["view"],
      Permissions: [],
      file_types: ["image", "office", "media", "other"],
      fileButtons: [
        {
          id: "1",
          name: "edit",
        },
        {
          id: "1",
          name: "download", // دانلود
          href: true,
        },
      ],
    };
  },
  computed: {
    ...mapState(["userInfo"]),
    userInfo() {
      return this.$store.state.profile.userInfo;
    },
    acting_status_options() {
      return renderEumOptions("acting_status");
    },
  },
  methods: {
    handleBack() {
      if (this.isModal) {
        this.$emit("modal-end-up");
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },

    async postContactUs() {
      this.$v.$touch();

      if (this.$v.$anyError) {
        return;
      }
      this.loading = true;
      try {
        let payload = {
          acting_description: this.acting_description,
          acting_status_id:
            this.acting_status_selected && this.acting_status_selected.value,
        };
        const response = await this.contactUsRepository.partial_edit(
          this.id,
          payload
        );
        this.$notify.success(response.data.message);
        this.loading = false;
      } catch (error) {
        this.$generateError(error);
        this.loading = false;
      }
    },
    async postSms() {
      try {
        this.disableSendSms = true;
        this.loading = true;
        let payload = {
          mobile: this.item.mobile,
          content: this.message_sms,
        };
        const url = this.$config.api_url + this.$config.resources.sms;
        const response = await this.$httpService.post(url, payload);
        this.$notify.success(response.data.message);

        this.loading = false;
      } catch (error) {
        this.$generateError(error);
        this.loading = false;
      }
    },
    async fetchData() {
      try {
        this.loadingItem = true;
        const response = await this.contactUsRepository.find(this.id);
        this.item = response.data.data;
        this.acting_description = response.data.data.acting_description;
        this.permistions = response.data.permissions;
        this.acting_status_selected = this.acting_status_options.find(
          (x) => x.value == pathOr(null, ["acting_status", "id"], this.item)
        );
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loadingItem = false;
      }
    },
  },
  created() {
    this.fetchData();
  },
};
</script>

<style>
.headerContact {
  position: absolute;
  top: -12px;
  background: white;
  padding: 0 10px;
}
</style>
